define(function (require) {

    var _ = require('underscore');
    var Backbone = require("backbone");
    var Bubble = require("ui/bubble/Bubble");
    var TableHeaderViewControllerBubbleCollectionView = require("web-agent-views/TableHeaderViewControllerBubbleCollectionView");
    var ViewController = require('web-agent-framework/ViewController');
    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    var TableHeaderViewController = ViewController.extend({
        ControllerName: "TableHeaderViewController",

        LPViewMap: {
            tableHead: ".lpview_table_thead",
            sortColumn: ".lpview_sort_column",
            filterColumn: ".lpview_filter_column",
            filterButton: ".lpview_filterButton",
            filterWindow: ".lpview_filterWindow",
            table_filters_container: ".lpview_table_filters_container"
        },

        LPViewClassesForInjectionMap: {
            sortColumn: "lpview_sort_column",
            filterColumn: "lpview_filter_column"
        },

        LPIconStatus: {
            on: "on",
            off: "off",
            show: "show",
            hide: "hide"
        },

        LPClassesMap: {
            descending: 'desc',
            ascending: 'asc',
            sortArrows: 'sort_arrows',
            filterShow: 'filter_show',
            filterOn: 'filter_on',
            filterIdPrefix: "filterId"

        },

        LPPrefixMap: {
            sortBy: "sort-by-"
        },

        LPEventsMap: {
            mouseEnter: 'mouseenter',
            mouseLeave: 'mouseleave'
        },

        LPTranslate: {
            learnMore: 'LEFramework.global.captions.learnMore'
        },

        logger: WebAgentLogger.getLogger(this.applicationType),

        initialize: function (constructorData) {
            this.columnsData = constructorData.columnsData || [];
            this.headerColumnTemplateFile = constructorData.headerColumnTemplateFile || "LP_table_header_item.html";
            this.headerRowClassName = "row table_header " + (constructorData.headerRowClassName || "");
            this.tableName = constructorData.tableName;
            this.textsPrefix = constructorData.textsPrefix;
            this.defaultSortTag = constructorData.defaultSortTag;
            this.updateQueryCallback = constructorData.updateQueryCallback;
            this.tableContainer = constructorData.tableContainer;
            this.tableItemsStateModelPath = constructorData.tableItemsStateModelPath;
            this.tableLastSentQueryModelPath = constructorData.tableLastSentQueryModelPath;
            this.notifyFilterOpenedCallback = constructorData.notifyFilterOpenedCallback;
            this.notifyFilterClosedCallback = constructorData.notifyFilterClosedCallback;
            this.context = constructorData.context || this;

            this.filterManager = [];
            this.filterIdPrefix = this.tableName + "_" + this.LPClassesMap.filterIdPrefix;
            this.filtersEnabled = true;

            this.bubbleEvents = [];

            this.initializeView();

            this.initializeFilters();
        },

        events: function () {
            this.view = this.getFirstElement(this.LPViewMap.tableHead, this.tableContainer);
            this.viewEventsHandler.bindEvent({appName: this.tableName, UIEvent: this.viewEventsHandler.eventType.TABLE_FILTERING_CHANGED, callback: this.setFilter});
            this.viewEventsHandler.bindEvent({appName: this.tableName, UIEvent: this.viewEventsHandler.eventType.TABLE_CONTENT_CHANGED, callback: this.bindEvents});
            this.viewEventsHandler.bindEvent({appName: this.tableName, UIEvent: this.viewEventsHandler.eventType.TABLE_FILTER_CLOSED, callback: this.onFilterClosed});
            this.bindModel({modelPath : this.tableItemsStateModelPath, callback : this.handleTableStateChanged});
            // Note: DO NOT add view events binding here! the table's DOM element will get replaced due to the fact it is an HTML table.
            // Binding view events can be done in the "bindViewEvents()" method that is activated every time the table content is changed.
            this.bindViewEvents();
        },

        render: function () {
        }
    });

    TableHeaderViewController.prototype.initializeView = function () {
        var headerColumnTemplate = require('web-agent-templates/' + this.headerColumnTemplateFile);
        // var headerColumnTemplate = lpUtils.loadResource(this.headerColumnTemplateFile);
        var headerColumnsHtml = "";

        for (var i = 0; i < this.columnsData.length; i++) {
            var textInjection = {
                title: this.columnsData[i].title ? "{{" + this.columnsData[i].title + "}}" : "",
                columnIndex: "c" + (i + 1),
                columnSort: this.columnsData[i].sortTag ? this.LPViewClassesForInjectionMap.sortColumn : "",
                columnSortType: this.columnsData[i].sortTag ? this.LPPrefixMap.sortBy + this.columnsData[i].sortTag : "",
                sortArrows: this.columnsData[i].sortTag ? this.LPClassesMap.sortArrows : "",
                icon: this.columnsData[i].iconType ? "icon" : "",
                iconType: this.columnsData[i].iconType || "",
                iconState: this.columnsData[i].iconState || "",
                dataPersonalization: this.columnsData[i].dataPersonalization || '',
                hasFilter: this.columnsData[i].filter ? "has_filter" : "",
                filterButton: this.columnsData[i].filter ? "<span class='filterButton lpview_filterButton " + this.filterIdPrefix + i + " {{filter_on}}'></span>" : "",
                filter_on: this.columnsData[i].filter && this.columnsData[i].filter.filterManagerData && this.columnsData[i].filter.filterManagerData.defaultFilter && this.columnsData[i].filter.filterManagerData.defaultFilterIsActive ? "filter_on" : ""
            };


            if(this.columnsData[i].tooltipMoreInfoCallback) {

                this.bubbleEvents.push({
                    columnIndex: i,
                    columnSelector: '.table_cell_content',
                    DOMEvent: this.LPEventsMap.mouseEnter,
                    callback: showBubble,
                    lpEventData: {
                        tooltip: this.translate(this.columnsData[i].tooltip),
                        position: this.columnsData[i].tooltipPosition || "top",
                        urlCallback: this.columnsData[i].tooltipMoreInfoCallback,
                        urlText: this.translate(this.columnsData[i].tooltipUrlText || this.LPTranslate.learnMore)
                    }
                });

                this.bubbleEvents.push({
                    columnIndex: i,
                    columnSelector: '.table_cell_content',
                    DOMEvent: this.LPEventsMap.mouseLeave,
                    callback: hideBubble
                });

                textInjection.tooltip = "";

            } else {
                _.assign(textInjection, {
                    tooltip: this.columnsData[i].tooltip ? "{{" + this.columnsData[i].tooltip + "}}" : "",
                    tooltipPosition: this.columnsData[i].tooltipPosition || "top",
                    tooltipAlign: this.columnsData[i].tooltipAlign || ""
                });
            }

            headerColumnsHtml += this.injectTextDefaults(headerColumnTemplate, textInjection);
        }
        headerColumnsHtml = '<tr class=\"' + this.headerRowClassName + '\">' + headerColumnsHtml + '</tr>';
        headerColumnsHtml = this.injectTextDefaults(headerColumnsHtml);
        this.view = lpUtils.replaceTableNodeContent(this.view, headerColumnsHtml);

        function showBubble(e) {
            var eventData;
            if (!this.bubbleComponent) {
                eventData = e.lpEventData || {};
                createAndRenderBubble.call(this, eventData);
            }
        }

        function hideBubble() {
            if (this.bubbleComponent) {
                this.bubbleComponent.close();
                delete this.bubbleComponent;
            }
        }

        function createAndRenderBubble(eventData) {
            this.bubbleComponent = new Bubble({
                containerSelector: '.web-agent-wrapper',
                targetControl: eventData.targetElement,
                contentView: new TableHeaderViewControllerBubbleCollectionView({
                    collection: new Backbone.Collection({tooltip: eventData.tooltip, urlCallback: eventData.urlCallback, urlText: eventData.urlText})
                }),
                preventCloseOnBubbleMouseEnter: true,
                position: Bubble.POSITION[eventData.position.toUpperCase()],
                isDelayed: true
            });
            this.bubbleComponent.render();
        }


    };
    /**
     * Add the filters to the view
     * filter: {
        filterManager: *The filter ViewController*,
        filterManagerData: {
            * Filter param *
        }
    }
     *
     */
    TableHeaderViewController.prototype.initializeFilters = function () {
        // Go over each title and check if filter need to be added
        for (var i = 0; i < this.columnsData.length; i++) {
            if (this.columnsData[i].filter) {
                this.columnsData[i].filter.filterManagerData.hidden = true;
                this.columnsData[i].filter.filterManagerData.tableName = this.tableName;
                this.columnsData[i].filter.filterManagerData.left = 26;
                this.columnsData[i].filter.filterManagerData.iconId = i;
                this.columnsData[i].filter.filterManagerData.iconCallback = this.setFilterIcon;
                this.columnsData[i].filter.filterManagerData.iconContext = this;
                this.columnsData[i].filter.filterManagerData.notifyFilterClosedCallback = this.notifyFilterClosedCallback;

                this.filterManager[i] = new this.columnsData[i].filter.filterManager(this.columnsData[i].filter.filterManagerData);

                this.addViewController({viewController: this.filterManager[i], target: this.getFirstElement(this.LPViewMap.table_filters_container, this.tableContainer)});
            }
        }
    };
    TableHeaderViewController.prototype.bindEvents = function (e) {
        // We receive in the event a reference to the table after the body replacement from the TableViewController.
        // We update our "this.view" reference to make sure the bind will refer to the current node in the DOM.
        var newTableHead = this.getFirstElement(this.LPViewMap.tableHead, e.newValue.eventData.tableRef);
        if (this.view !== newTableHead) {
            this.unbindViewEvents();
            this.view = newTableHead;
            this.bindViewEvents();
            this.setInitialSortState();
        }
    };

    TableHeaderViewController.prototype.setFiltersStatus = function (status) {
        this.filtersEnabled = status;
    };

    TableHeaderViewController.prototype.bindViewEvents = function (e) {
        this.bindViewEvent({selector: this.LPViewMap.sortColumn, DOMEvent: "click", callback: this.sortColumnClicked});
        this.bindViewEvent({selector: this.LPViewMap.filterButton, DOMEvent: "click", callback: this.showFilter});
        _.each(this.bubbleEvents, _.bind(function(bubbleEvent) {
            var element = this.getElements(bubbleEvent.columnSelector)[bubbleEvent.columnIndex];
            this.bindViewEvent({view: element, DOMEvent: bubbleEvent.DOMEvent, callback: bubbleEvent.callback, lpEventData: _.extend(bubbleEvent.lpEventData,{targetElement: element})});
        },this));
    };

    TableHeaderViewController.prototype.unbindViewEvents = function (e) {
        this.unbindViewEvent({selector: this.LPViewMap.sortColumn, DOMEvent: "click", callback: this.sortColumnClicked});
        this.unbindViewEvent({selector: this.LPViewMap.filterButton, DOMEvent: "click", callback: this.showFilter});
        _.each(this.bubbleEvents, _.bind(function(bubbleEvent) {
            var element = this.getElements(bubbleEvent.columnSelector)[bubbleEvent.columnIndex];
            this.unbindViewEvent({view: element, DOMEvent: bubbleEvent.DOMEvent, callback: bubbleEvent.callback});
        },this));
    };

    TableHeaderViewController.prototype.setInitialSortState = function () {
        this.currentSortedColumnElement = this.getFirstElement("." + this.LPPrefixMap.sortBy + this.currentSortTag);
        this.setSortState();
    };

    TableHeaderViewController.prototype.sortColumnClicked = function (data) {
        var clickedElement = data.currentTarget;
        var clickedElementSortTag = this.getSortTag(clickedElement);

        if (this.currentSortTag !== clickedElementSortTag) {
            this.setSortState(clickedElement, clickedElementSortTag, this.LPClassesMap.ascending);
        } else {
            var newSortingOrder = this.currentSortOrder === this.LPClassesMap.ascending ? this.LPClassesMap.descending : this.LPClassesMap.ascending;
            this.setSortState(null, null, newSortingOrder);
        }
        this.setSort(this.currentSortTag, this.currentSortOrder);
    };

    TableHeaderViewController.prototype.getSortTag = function (element) {
        var elementClassMap = element.className.split(" ");
        for (var i = 0; i < elementClassMap.length; i++) {
            if (elementClassMap[i].indexOf(this.LPPrefixMap.sortBy) != -1) {
                return elementClassMap[i].substring(this.LPPrefixMap.sortBy.length);
            }
        }
    };

    TableHeaderViewController.prototype.setSortState = function (clickedElement, clickedSortTag, newSortingOrder) {
        if (this.currentSortedColumnElement) {
            this.removeClass(this.currentSortedColumnElement, [this.LPClassesMap.ascending, this.LPClassesMap.descending]);
        }
        this.currentSortedColumnElement = clickedElement || this.currentSortedColumnElement;
        this.currentSortTag = clickedSortTag || this.currentSortTag;
        this.currentSortOrder = newSortingOrder || this.currentSortOrder;
        if (this.currentSortedColumnElement) {
            this.addClass(this.currentSortedColumnElement, this.currentSortOrder);
        }
    };

    TableHeaderViewController.prototype.setSort = function (sortTag, sortOrder) {
        this.updateQueryCallback.call(this.context, {sortTag: sortTag, sortOrder: sortOrder, startPage: true});
    };

    TableHeaderViewController.prototype.setFilter = function (data) {
        this.updateQueryCallback.call(this.context, data.newValue.eventData);
    };

    /**
     * Show the filter after setting the location of filter_container to the title position
     * @param e - the click event
     */
    TableHeaderViewController.prototype.showFilter = function (e) {
        if(this.filtersEnabled) {
            var element = e.sourceElement;
            var left = element.getBoundingClientRect().left;
            var parentLeft = element.parentNode.getBoundingClientRect().left;
            var classNameArray = element.className.split(" ");
            var filterContainerElement = this.getFirstElement(this.LPViewMap.table_filters_container, this.tableContainer);
            var topArrowElement = this.getFirstElement(this.LPViewMap.top_arrow);
            var id = -1;
            // find the id of the clicked button
            var that = this;
            classNameArray.map(function (className) {
                if(className.indexOf(that.filterIdPrefix) >= 0){
                    id = parseInt(className.replace(that.filterIdPrefix,""),10);
                }
            });
            filterContainerElement.style.left = (parentLeft - 17) + "px";
            this.notifyFilterOpenedCallback.call(this, this.filterManager[id].filterName);
            this.onFilterOpened(e.srcElement || e.target);
            // If the filter is out of the table from the right side, move the filter back in.
            var fixWidth = 0;
            var filterWindowRight = this.getFirstElement(this.LPViewMap.filterWindow, this.filterManager[id].view).getBoundingClientRect().right;
            var tableRight = this.tableContainer.getBoundingClientRect().right - 20; // remove 20px for the right padding of the table
            if (tableRight < filterWindowRight) {
                fixWidth = filterWindowRight - tableRight;
                filterContainerElement.style.left = (filterContainerElement.getBoundingClientRect().left - fixWidth - 20) +"px";
            }
            if(topArrowElement && topArrowElement.parentNode) {
                this.filterManager[id].alignPosition(topArrowElement.parentNode, left - parentLeft + 4 + fixWidth);
            } else {
                this.logger.error("Couldn't find filter's top arrow in DOM");
            }
        }
    };

    TableHeaderViewController.prototype.onFilterOpened = function(filterView) {
        this.openedFilterView = filterView;
        this.unbindViewEvent({view: this.openedFilterView, DOMEvent: "click", callback: this.showFilter});
    };

    TableHeaderViewController.prototype.onFilterClosed = function() {
        var that = this;
        var openedFilterView = this.openedFilterView;
        setTimeout(function() {
            that.bindViewEvent({view: openedFilterView, DOMEvent: "click", callback: that.showFilter});
        },200);
    };

    /**
     * Set the filter icon status
     * @param context
     * @param iconId
     * @param status - show, hide, on, off
     */
    TableHeaderViewController.prototype.setFilterIcon = function (iconId, status) {
        switch (status) {
            case this.LPIconStatus.on:
                this.addClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.off:
                this.removeClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.show:
                this.addClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterShow); break;
            case this.LPIconStatus.hide:
                this.removeClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterShow); break;
        }
    };

    TableHeaderViewController.prototype.handleTableStateChanged = function(data){
        if(data && data.newValue && (data.newValue.status === "fetched" ||
            data.newValue.status === "error") ) {
            var lastQuery = this.getModelParam(this.tableLastSentQueryModelPath);
            if(lastQuery){
                for(var idx = 0; idx < this.filterManager.length; ++ idx){
                    if(this.filterManager[idx] && this.filterManager[idx].filterName){
                        this.filterManager[idx].setFilter(lastQuery[this.filterManager[idx].filterName]);
                    }
                }
                this.setSortState(this.getFirstElement("." + this.LPPrefixMap.sortBy + lastQuery.sortTag),lastQuery.sortTag, lastQuery.sortOrder);
            }
        }
    };

    TableHeaderViewController.prototype.isTableFilterSet = function(){
        for (var i=0; i<this.filterManager.length; i++) {
            if (this.filterManager[i] && this.filterManager[i].isFilterSet()) {
                return true;
            }
        }
        return false;
    };

    // todo - lose the global namespace assignment
    window.TableHeaderViewController =  TableHeaderViewController;


    return TableHeaderViewController;

});
